import { containsUrl } from "./contains-url.js";
import { isValidTelUrl } from "./is-valid-te-url.js";
const isValidUrl = (url, options = {}) => !!url && (containsUrl(url) || !!(options.allowTelLink && isValidTelUrl(url)));
export {
  isValidUrl
};
//# sourceMappingURL=is-valid-url.js.map
